import showMe from "@/hooks/useGetMe"
import { Box, Stack, Typography } from "@mui/material"
import EditIcon from "@mui/icons-material/Edit"

import { UserIcon } from "@/components/users/UserIcon"
import { useEffect, useState } from "react"
import ExperienceCollectionFilters from "@/components/users/ExperienceCollectionFilters"
import useDialogState from "@/hooks/useDialogState"
import ProfilePictureDialog from "@/dialogs/ProfilePictureDialog"
import useIsMobile from "@/hooks/useIsMobile"

type UserProfile = [
  {
    user_number: number
    email: string
    display_name: string
    role: number
    profile_picture_link: string
    first_name: string
    last_name: string
  }
]

const Profile = () => {
  const isMobile = useIsMobile()
  const [userProfile, setUserProfile] = useState<UserProfile>()
  const [hover, setHover] = useState<boolean>()
  const { openDialog, ...dialogState } = useDialogState({})

  useEffect(() => {
    showMe().then((profile: UserProfile) => {
      setUserProfile(profile)
    })
  }, [])

  const userPicture = userProfile && userProfile[0]?.profile_picture_link
  const displayName =
    userProfile && userProfile[0]?.display_name
      ? userProfile[0].display_name
      : userProfile &&
        userProfile[0]?.first_name + " " + userProfile[0]?.last_name

  return (
    <Box
      className="theme-bluecontainer"
      sx={{
        padding: "2rem",
        minHeight: "100vh",
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        alignContent: "center",
        color: "white",
        justifyContent: isMobile ? "normal" : "space-between",
      }}
    >
      <Box sx={{ width: isMobile ? "100%" : "33%" }}>
        <ExperienceCollectionFilters />
      </Box>
      <Box
        display="flex"
        width={isMobile ? "100%" : "33%"}
        sx={{ order: isMobile ? -1 : 2, paddingBottom: isMobile ? 2 : 0 }}
      >
        <Box
          sx={{
            position: "relative",
            width: isMobile ? 60 : 120,
            height: isMobile ? 60 : 120,
            borderRadius: "50%",
            overflow: "hidden",
            cursor: "pointer",
            textAlign: "center",
            display: "inline-block",
          }}
          onClick={openDialog}
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
        >
          {userPicture ? (
            <Box
              component="img"
              src={userPicture}
              sx={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: "50%",
              }}
            />
          ) : (
            <UserIcon
              dimensions={{
                width: "100%",
                height: "100%",
                // objectFit: "cover",
                // borderRadius: "50%",
              }}
              borderRadius="50%"
            />
          )}
          {hover && (
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.4)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                opacity: 0,
                transition: "opacity 0.3s",
                zIndex: 1,
              }}
              className="hover-overlay"
            >
              <EditIcon sx={{ color: "white", fontSize: 30 }} />
            </div>
          )}
        </Box>
        <Stack
          gap={2}
          sx={{
            paddingLeft: "20px",
          }}
        >
          <Typography variant="h2" color="white">
            {displayName}
          </Typography>
          <Typography color="white">0 connections</Typography>
        </Stack>
      </Box>
      <Box sx={{ width: "33%" }}></Box>
      {userProfile && (
        <ProfilePictureDialog
          {...dialogState}
          userPicture={userPicture}
          userProfile={userProfile}
        />
      )}
    </Box>
  )
}

export default Profile
